import { render, staticRenderFns } from "./product_inside.vue?vue&type=template&id=2b18e3e2&scoped=true&"
import script from "./product_inside.vue?vue&type=script&lang=js&"
export * from "./product_inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18e3e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b18e3e2')) {
      api.createRecord('2b18e3e2', component.options)
    } else {
      api.reload('2b18e3e2', component.options)
    }
    module.hot.accept("./product_inside.vue?vue&type=template&id=2b18e3e2&scoped=true&", function () {
      api.rerender('2b18e3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/inside_list/product_inside.vue"
export default component.exports